export const Theme = {
  AtlantaHawks: "AtlantaHawks",
  BostonCeltics: "BostonCeltics",
  BrooklynNets: "BrooklynNets",
  CharlotteHornets: "CharlotteHornets",
  ChicagoBulls: "ChicagoBulls",
  ClevelandCavaliers: "ClevelandCavaliers",
  DallasMavericks: "DallasMavericks",
  DenverNuggets: "DenverNuggets",
  DetroitPistons: "DetroitPistons",
  GoldenStateWarriors: "GoldenStateWarriors",
  HoustonRockets: "HoustonRockets",
  IndianaPacers: "IndianaPacers",
  LosAngelesClippers: "LosAngelesClippers",
  LosAngelesLakers: "LosAngelesLakers",
  MemphisGrizzlies: "MemphisGrizzlies",
  MiamiHeat: "MiamiHeat",
  MilwaukeeBucks: "MilwaukeeBucks",
  MinnesotaTimberwolves: "MinnesotaTimberwolves",
  NewOrleansPelicans: "NewOrleansPelicans",
  NewYorkKnicks: "NewYorkKnicks",
  OklahomaCityThunder: "OklahomaCityThunder",
  OrlandoMagic: "OrlandoMagic",
  Philadelphia76ers: "Philadelphia76ers",
  PhoenixSuns: "PhoenixSuns",
  PortlandTrailBlazers: "PortlandTrailBlazers",
  SacramentoKings: "SacramentoKings",
  SanAntonioSpurs: "SanAntonioSpurs",
  TorontoRaptors: "TorontoRaptors",
  UtahJazz: "UtahJazz",
  WashingtonWizards: "WashingtonWizards",
  AtlantaDream: "AtlantaDream",
  ChicagoSky: "ChicagoSky",
  ConnecticutSun: "ConnecticutSun",
  DallasWings: "DallasWings",
  IndianaFever: "IndianaFever",
  LasVegasAces: "LasVegasAces",
  LosAngelesSparks: "LosAngelesSparks",
  MinnesotaLynx: "MinnesotaLynx",
  NewYorkLiberty: "NewYorkLiberty",
  PhoenixMercury: "PhoenixMercury",
  SeattleStorm: "SeattleStorm",
  WashingtonMystics: "WashingtonMystics",
  GoldenStateValkyries: "GoldenStateValkyries",
} as const;

export const themes: Readonly<Array<{
  name: string,
  abbreviation: string,
  slug: keyof typeof Theme,
  primaryColor: string,
  secondaryColor: string,
  league: "WNBA" | "NBA",
  slogan?: string,
}>> = [
  {
    name: "Atlanta Hawks",
    abbreviation: "ATL",
    slug: "AtlantaHawks",
    primaryColor: "#C8102E",
    secondaryColor: "#FDB927",
    league: "NBA",
  },
  {
    name: "Boston Celtics",
    abbreviation: "BOS",
    slug: "BostonCeltics",
    primaryColor: "#007A33",
    secondaryColor: "#BA9653",
    league: "NBA",
  },
  {
    name: "Brooklyn Nets",
    abbreviation: "BKN",
    slug: "BrooklynNets",
    primaryColor: "#000000",
    secondaryColor: "#C6CFD4",
    league: "NBA",
  },
  {
    name: "Charlotte Hornets",
    abbreviation: "CHA",
    slug: "CharlotteHornets",
    primaryColor: "#1d1160",
    secondaryColor: "#00788C",
    league: "NBA",
  },
  {
    name: "Chicago Bulls",
    abbreviation: "CHI",
    slug: "ChicagoBulls",
    primaryColor: "#000000",
    secondaryColor: "#CE1141",
    league: "NBA",
  },
  {
    name: "Cleveland Cavaliers",
    abbreviation: "CLE",
    slug: "ClevelandCavaliers",
    primaryColor: "#860038",
    secondaryColor: "#FDBB30",
    league: "NBA",
    slogan: "Defend the land",
  },
  {
    name: "Dallas Mavericks",
    abbreviation: "DAL",
    slug: "DallasMavericks",
    primaryColor: "#00538C",
    secondaryColor: "#B8C4CA",
    league: "NBA",
  },
  {
    name: "Denver Nuggets",
    abbreviation: "DEN",
    slug: "DenverNuggets",
    primaryColor: "#0E2240",
    secondaryColor: "#FEC524",
    league: "NBA",
  },
  {
    name: "Detroit Pistons",
    abbreviation: "DET",
    slug: "DetroitPistons",
    primaryColor: "#1d42ba",
    secondaryColor: "#C8102E",
    league: "NBA",
    slogan: "Deee-troit basketball",
  },
  {
    name: "Golden State Warriors",
    abbreviation: "GSW",
    slug: "GoldenStateWarriors",
    primaryColor: "#1D428A",
    secondaryColor: "#ffc72c",
    league: "NBA",
  },
  {
    name: "Houston Rockets",
    abbreviation: "HOU",
    slug: "HoustonRockets",
    primaryColor: "#CE1141",
    secondaryColor: "#C4CED4",
    league: "NBA",
  },
  {
    name: "Indiana Pacers",
    abbreviation: "IND",
    slug: "IndianaPacers",
    primaryColor: "#002D62",
    secondaryColor: "#FDBB30",
    league: "NBA",
    slogan: "Yes ‘Cers",
  },
  {
    name: "Los Angeles Clippers",
    abbreviation: "LAC",
    slug: "LosAngelesClippers",
    primaryColor: "#1d428a",
    secondaryColor: "#c8102E",
    league: "NBA",
  },
  {
    name: "Los Angeles Lakers",
    abbreviation: "LAL",
    slug: "LosAngelesLakers",
    primaryColor: "#552583",
    secondaryColor: "#FDB927",
    league: "NBA",
  },
  {
    name: "Memphis Grizzlies",
    abbreviation: "MEM",
    slug: "MemphisGrizzlies",
    primaryColor: "#12173F",
    secondaryColor: "#5D76A9",
    league: "NBA",
  },
  {
    name: "Miami Heat",
    abbreviation: "MIA",
    slug: "MiamiHeat",
    primaryColor: "#000000",
    secondaryColor: "#98002E",
    league: "NBA",
  },
  {
    name: "Milwaukee Bucks",
    abbreviation: "MIL",
    slug: "MilwaukeeBucks",
    primaryColor: "#00471B",
    secondaryColor: "#EEE1C6",
    league: "NBA",
    slogan: "Fear the deer",
  },
  {
    name: "Minnesota Timberwolves",
    abbreviation: "MIN",
    slug: "MinnesotaTimberwolves",
    primaryColor: "#0C2340",
    secondaryColor: "#236192",
    league: "NBA",
  },
  {
    name: "New Orleans Pelicans",
    abbreviation: "NOP",
    slug: "NewOrleansPelicans",
    primaryColor: "#0C2340",
    secondaryColor: "#85714D",
    league: "NBA",
  },
  {
    name: "New York Knicks",
    abbreviation: "NYK",
    slug: "NewYorkKnicks",
    primaryColor: "#006BB6",
    secondaryColor: "#F58426",
    league: "NBA",
    slogan: "Always Knicks",
  },
  {
    name: "Oklahoma City Thunder",
    abbreviation: "OKC",
    slug: "OklahomaCityThunder",
    primaryColor: "#007ac1",
    secondaryColor: "#ef3b24",
    league: "NBA",
    slogan: "Thunder up",
  },
  {
    name: "Orlando Magic",
    abbreviation: "ORL",
    slug: "OrlandoMagic",
    primaryColor: "#0077c0",
    secondaryColor: "#C4ced4",
    league: "NBA",
  },
  {
    name: "Philadelphia 76ers",
    abbreviation: "PHI",
    slug: "Philadelphia76ers",
    primaryColor: "#006bb6",
    secondaryColor: "#ed174c",
    league: "NBA",
    slogan: "Trust the process",
  },
  {
    name: "Phoenix Suns",
    abbreviation: "PHX",
    slug: "PhoenixSuns",
    primaryColor: "#1d1160",
    secondaryColor: "#e56020",
    league: "NBA",
  },
  {
    name: "Portland Trail Blazers",
    abbreviation: "POR",
    slug: "PortlandTrailBlazers",
    primaryColor: "#000000",
    secondaryColor: "#E03A3E",
    league: "NBA",
  },
  {
    name: "Sacramento Kings",
    abbreviation: "SAC",
    slug: "SacramentoKings",
    primaryColor: "#5a2d81",
    secondaryColor: "#63727A",
    league: "NBA",
    slogan: "Light the beam",
  },
  {
    name: "San Antonio Spurs",
    abbreviation: "SAS",
    slug: "SanAntonioSpurs",
    primaryColor: "#000000",
    secondaryColor: "#c4ced4",
    league: "NBA",
  },
  {
    name: "Toronto Raptors",
    abbreviation: "TOR",
    slug: "TorontoRaptors",
    primaryColor: "#000000",
    secondaryColor: "#ce1141",
    league: "NBA",
    slogan: "We the north",
  },
  {
    name: "Utah Jazz",
    abbreviation: "UTA",
    slug: "UtahJazz",
    primaryColor: "#002B5C",
    secondaryColor: "#F9A01B",
    league: "NBA",
  },
  {
    name: "Washington Wizards",
    abbreviation: "WAS",
    slug: "WashingtonWizards",
    primaryColor: "#002B5C",
    secondaryColor: "#e31837",
    league: "NBA",
  },
  {
    name: "Atlanta Dream",
    abbreviation: "ATL",
    slug: "AtlantaDream",
    primaryColor: "#418FDE",
    secondaryColor: "#C8102E",
    league: "WNBA",
  },
  {
    name: "Chicago Sky",
    abbreviation: "CHI",
    slug: "ChicagoSky",
    primaryColor: "#418FDE",
    secondaryColor: "#FFCD00",
    league: "WNBA",
  },
  {
    name: "Connecticut Sun",
    abbreviation: "CON",
    slug: "ConnecticutSun",
    primaryColor: "#041E42",
    secondaryColor: "#DC4405",
    league: "WNBA",
  },
  {
    name: "Dallas Wings",
    abbreviation: "DAL",
    slug: "DallasWings",
    primaryColor: "#0C2340",
    secondaryColor: "#C4D600",
    league: "WNBA",
  },
  {
    name: "Indiana Fever",
    abbreviation: "IND",
    slug: "IndianaFever",
    primaryColor: "#041E42",
    secondaryColor: "#C8102E",
    league: "WNBA",
  },
  {
    name: "Las Vegas Aces",
    abbreviation: "LVA",
    slug: "LasVegasAces",
    primaryColor: "#000000",
    secondaryColor: "#BA0C2F",
    league: "WNBA",
  },
  {
    name: "Los Angeles Sparks",
    abbreviation: "LAS",
    slug: "LosAngelesSparks",
    primaryColor: "#702F8A",
    secondaryColor: "#FFC72C",
    league: "WNBA",
  },
  {
    name: "Minnesota Lynx",
    abbreviation: "MIN",
    slug: "MinnesotaLynx",
    primaryColor: "#236192",
    secondaryColor: "#78BE20",
    league: "WNBA",
  },
  {
    name: "New York Liberty",
    abbreviation: "NYL",
    slug: "NewYorkLiberty",
    primaryColor: "#000000",
    secondaryColor: "#6ECEB2",
    league: "WNBA",
    slogan: "Liberty loud",
  },
  {
    name: "Phoenix Mercury",
    abbreviation: "PHX",
    slug: "PhoenixMercury",
    primaryColor: "#201747",
    secondaryColor: "#CB6015",
    league: "WNBA",
  },
  {
    name: "Seattle Storm",
    abbreviation: "SEA",
    slug: "SeattleStorm",
    primaryColor: "#2C5234",
    secondaryColor: "#FBE122",
    league: "WNBA",
  },
  {
    name: "Washington Mystics",
    abbreviation: "WAS",
    slug: "WashingtonMystics",
    primaryColor: "#0C2340",
    secondaryColor: "#C8102E",
    league: "WNBA",
  },
  {
    name: "Golden State Valkyries",
    abbreviation: "GSV",
    slug: "GoldenStateValkyries",
    primaryColor: "#000000",
    secondaryColor: "#B896D4",
    league: "WNBA",
    slogan: "Ballhalla",
  },
];

export const themeMap = new Map(themes.map((theme) => [theme.slug, theme]));
